$( document ).ready(function() {
    var $items = $('.js-trigger-lazy');

    if ($items.length==0) return false;

    $items.each(function() {
        var $item = $(this);
        var $media = $item.find('.js-trigger-lazy-item');
        var $img = $item.find('img');


        $img.imagesLoaded(function() {
            $media
                .addClass('item-loaded')
                .find('.js-trigger-lazy-spinner').fadeOut(function() {
                $(this).remove();
            });
        });
    });
});